package dev.lingvo.site.components.studio.editor

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.Radius
import dev.lingvo.site.ds.toSitePalette
import dev.lingvo.site.i18n.tr
import dev.lingvo.site.i18n.trf
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img

/** The renderer port supplies cached thumbnails; composing the filmstrip never renders a document. */
@Composable
internal fun Filmstrip(state: StudioUiState, dispatch: (StudioIntent) -> Unit) {
    val palette = ColorMode.current.toSitePalette()
    Div(attrs = { attr("data-studio-region", "filmstrip"); attr("aria-label", tr("studio.editor.filmstrip.shots", "Shots")); tabIndex(-1)
        style {
            property("display", "flex"); property("min-width", "0"); property("overflow-x", "auto"); property("overflow-y", "hidden")
            property("gap", Space.SM.toString()); property("padding", Space.SM.toString())
            property("border", "1px solid ${palette.borderStrong}"); property("border-radius", Radius.Control.toString())
            property("scrollbar-gutter", "stable"); property("overscroll-behavior-inline", "contain")
        } }) {
        state.slots.forEach { slot ->
            Button(attrs = { attr("aria-current", if (slot.id == state.view.slotId) "true" else "false")
                attr("aria-label", trf("studio.shot_status", "{shot}: {status}", "shot" to slot.title, "status" to slot.status))
                onClick { dispatch(StudioIntent.Slot(slot.id)) }
                style {
                    property("flex", "0 0 120px"); property("min-width", "0"); property("min-height", "40px")
                    property("display", "grid"); property("justify-items", "center"); property("align-content", "start")
                    property("gap", Space.XS.toString()); property("padding", Space.XS.toString())
                    property("font", "inherit"); property("text-align", "start"); property("color", palette.textPrimary.toString())
                    property("background", palette.surface.toString()); property("border-radius", Radius.Control.toString())
                    property("border", "1px solid ${if (slot.id == state.view.slotId) palette.accent else palette.borderStrong}")
                }
            }) {
                slot.thumbnailUrl?.let { Img(it, alt = "", attrs = { attr("width", "56"); attr("height", "120"); style { property("object-fit", "contain") } }) }
                StudioNameStatus(slot.title, slot.status)
            }
        }
    }
}
